module.exports = __webpack_public_path__ + "static/media/katya-austin-4Vg6ez9jaec-unsplash.db7aee96.jpg";